/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SearchSelectTextFieldN.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import {
  Autocomplete,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";


function SearchSelectTextFieldN({
  size,
  label,
  placeholder,
  noOptionsText,
  optionsList,
  selectedValue,
  handleValueChange,
  txtFldStyle,
  disableClearable = true,
}) {
  return (
    <Autocomplete
      disablePortal
      disableClearable={disableClearable}
      options={optionsList}
      value={selectedValue}
      noOptionsText={noOptionsText}
      onChange={handleValueChange}
      sx={{ width: "100%" }}
      slotProps={{
        popper: {
          sx: { minWidth: 280 },
        },
      }}
      ListboxProps={{
        sx: {
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          borderRadius: 2,
          backgroundColor: "#fff",
          "& .MuiAutocomplete-option": {
            justifyContent: "flex-start",
            textAlign: "left",
          },
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          fullWidth
          InputLabelProps={{
            shrink: true,
            sx: {
              fontWeight: 600,
              color: "#4A5568",
              fontSize: "0.75rem",
              backgroundColor: "#fff",
              px: 0.5,
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            sx: {
              borderRadius: 3,
              backgroundColor: "#fff",
              fontSize: "0.875rem",
              boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#000",
              },
              ...txtFldStyle,
            },
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: "off",
          }}
        />
      )}
    />
  );
}

export default SearchSelectTextFieldN;
